import React, { useState, useContext } from "react";
import "./AdminLogin.css";
import { Stepper, Step } from "react-form-stepper";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../../firebase.config";
import { Toaster, toast } from "react-hot-toast";
import OTPInput from "otp-input-react";
import { useNavigate } from "react-router-dom";
import clgocde_prici from "../../data/ccode_pno_map.json";
import userContext from "../../context/user-context";
import ClipLoader from "react-spinners/ClipLoader";

export const AdminLogin = () => {
	const { setuserclgcode, setCname } = useContext(userContext);

	const navigate = useNavigate();

	var clgname = "";

	const [stage1loader, setStage1loader] = useState(false);
	const [clgcode, setClgcode] = useState("");
	const [stepnumber, setstepnumber] = useState(0);
	const [priciphone, setPriciphone] = useState("");
	const [otp, setOtp] = useState();
	const [priciname, setPriciname] = useState("");

	const [password, setPassword] = useState("");

	const configureCaptchaVerify = () => {
		window.recaptchaVerifier = new RecaptchaVerifier(
			"sign-in-button",
			{
				size: "invisible",
				callback: (response) => {
					// reCAPTCHA solved, allow signInWithPhoneNumber.
					onSignInSubmit();
					console.log("Recaptcha verified");
				},
				defaultCountry: "IN"
			},
			auth
		);
	};

	const onSignInSubmit = (e) => {
		e.preventDefault();
		if (clgcode == "") {
			toast.error("Enter College Code");
			return;
		}

		var reqclg = clgocde_prici.find((clg) => clg.ccode.toString() == clgcode);
		if (reqclg == null || reqclg == undefined) {
			toast.error("College Code Doesnt exit");
			return;
		}
		setStage1loader(true);
		var phoneno = reqclg.pno.toString();
		var pname = reqclg.pname;
		configureCaptchaVerify();
		const phoneNumber = "+91" + phoneno;
		setPriciphone(phoneNumber);
		setPriciname(pname);
		console.log(phoneNumber);
		const appVerifier = window.recaptchaVerifier;
		signInWithPhoneNumber(auth, phoneNumber, appVerifier)
			.then((confirmationResult) => {
				// SMS sent. Prompt user to type the code from the message, then sign the
				// user in with confirmationResult.confirm(code).
				window.confirmationResult = confirmationResult;
				toast.success("OTP has been sent");
				console.log("OTP has been sent");
				setstepnumber(1);
				// ...
			})
			.catch((error) => {
				// Error; SMS not sent
				// ...
				toast.error("Too many login requests, Try after 1 hour");
				console.log(error);
				console.log("SMS not sent");
			});
	};

	const onSubmitOTP = (e) => {
		e.preventDefault();
		const code = otp;
		console.log(code);
		window.confirmationResult
			.confirm(code)
			.then((result) => {
				// User signed in successfully.
				const user = result.user;
				console.log(JSON.stringify(user));
				setuserclgcode(clgcode);
				navigate("/table");
				// ...
			})
			.catch((error) => {
				console.log(JSON.stringify(error));
				if (error) {
					toast.error("Invalid OTP");
				}

				// User couldn't sign in (bad verification code?)
				// ...
			});
	};

	return (
		<div className="loginpage">
			<Toaster />
			<div id="sign-in-button"></div>
			<div className="steppercont">
				<Stepper
					activeStep={stepnumber}
					styleConfig={{ activeBgColor: "indigo", completedBgColor: "indigo" }}
				>
					<Step label="Enter College Code" />
					<Step label="Enter Password" />
					<Step label="Login" />
				</Stepper>
			</div>

			<div className="logincontainer">
				<div className="loginlogocont" style={{ marginBottom: "10px" }}>
					{" "}
					<span className="loginlogo">Admin Login</span>
					<div className="logodash"></div>
				</div>

				<div className="logininputadmin">
					<div className="inputstyleadmin">
						<span>Enter College Code:</span>
						<input
							onChange={(e) => {
								setClgcode(e.target.value);
							}}
							type="text"
							placeholder="College Code"
						/>
					</div>
					<div className="inputstyleadmin">
						<span>Password:</span>
						<input
							onChange={(e) => {
								setPassword(e.target.value);
							}}
							type="text"
							placeholder="Password"
						/>
					</div>
					<button
						onClick={() => {
							if (password === "admin@1234") {
								setuserclgcode(clgcode);
								navigate("/table");
							} else {
								toast.error("Invalid Password");
							}
						}}
					>
						Login
					</button>
				</div>
			</div>
		</div>
	);
};
